export default "__VITE_ASSET__ef61a7b6__"